export abstract class APIException {
  message: string;

  constructor(message: string) {
    this.message = message;
  }
}